var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIntegrationLine = function SvgIntegrationLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1240,
    height: 363,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 139v128.5c0 11.598 9.402 21 21 21h226.5c11.598 0 21 9.402 21 21v31c0 11.598 9.402 21 21 21h79M1096.5 139v128.5c0 11.598-9.4 21-21 21H849c-11.598 0-21 9.402-21 21v31c0 11.598-9.402 21-21 21h-79M1.5 1.5v169c0 11.598 9.402 21 21 21H144M1239 1.5v169c0 11.598-9.4 21-21 21h-121.5M331.5 230.5V288M909 230.5V288",
    stroke: "#BCC2F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgIntegrationLine;